import React from 'react';


const Admin = ({width, height, color}) => {
    const getColor = (c) => {
        if (c === 'primary-500') return '#7F0689';
        if (c === 'secondary-500') return '#75D3A8';
        return c;
    };
    return (
        <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 10.625H5.625C4.57833 10.625 4.05499 10.625 3.62914 10.7542C2.67034 11.045 1.92003 11.7953 1.62918 12.7541C1.5 13.18 1.5 13.7033 1.5 14.75M14.25 14.75V10.25M12 12.5H16.5M10.875 4.625C10.875 6.48896 9.36396 8 7.5 8C5.63604 8 4.125 6.48896 4.125 4.625C4.125 2.76104 5.63604 1.25 7.5 1.25C9.36396 1.25 10.875 2.76104 10.875 4.625Z"
                stroke={getColor(color) || '#6E6C6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
export default Admin;
